exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".enhancer-ztree {\n\tfont-size: 14px;\n}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/index.css
 ** module id = 2
 ** module chunks = 0
 **/